import React, {useState, useRef} from "react";

import {useOnClickOutside} from "usehooks-ts";

import './OptionsMenu.css'

const CardOptionsMenu = ({onDelete, onEdit}) => {

    const [ optionsOpened, setOptionsOpened ] = useState(false)
    const handleOptionsClick = (e) => {
        setOptionsOpened(!optionsOpened)
    }
    const optionsRef = useRef(null)

    useOnClickOutside(optionsRef, () => {
        if (optionsOpened) {
            setOptionsOpened(false)
        }
    })

    return (
        <div className="relative">
        <div className="absolute top-0 right-0 p-[11px] cursor-pointer hover:scale-125" onClick={handleOptionsClick}>
            <svg width="11" height="3" viewBox="0 0 11 3" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="1.5" cy="1.5" r="1.5" fill="#D8D0FA"/>
            <circle cx="5.5" cy="1.5" r="1.5" fill="#D8D0FA"/>
            <circle cx="9.5" cy="1.5" r="1.5" fill="#D8D0FA"/>
            </svg>
        </div>
        { (optionsOpened) &&
            <div ref={optionsRef} className="absolute top-[4px] right-[4px] w-[139px] h-[84px] bg-white rounded-xl overflow-hidden">
                <ul>
                    <li className="option-item text-sm flex items-center justify-center cursor-pointer min-h-[42px] bg-white hover:bg-zinc-100 " onClick={onEdit}>Редактировать</li>
                    <li className="option-item text-sm flex items-center justify-center cursor-pointer min-h-[42px] bg-white hover:bg-zinc-100 " onClick={onDelete}>Удалить</li>
                </ul>
            </div>
        }
    </div>
    )
}

export default CardOptionsMenu